export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fcc1ab6c5e7b5c2695a722a0d41769965122d8cc9&name=fetchTypeahead!'